import React from 'react';
import type { JsonData } from '../types';

// Workaround for CommonJS module in ESM
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import ReactJson from 'react-json-view';

interface JsonEditorProps {
  json: JsonData;
  onChange: (newJson: JsonData) => void;
  readOnly?: boolean;
}

// Handle both ESM and CommonJS module exports
// The module might export the component as default or as the module itself
// @ts-expect-error - ReactJson is a CommonJS module that may have .default property
const JsonView = ReactJson.default ? ReactJson.default : ReactJson;

export const JsonEditor: React.FC<JsonEditorProps> = ({
  json,
  onChange,
  readOnly = false,
}) => {
  return (
    <div className="json-editor" style={{ padding: '16px', borderRadius: '8px', background: '#ffffff', height: '200px', overflow: 'auto' }}>
      <style>
        {`
          .json-editor .react-json-view,
          .json-editor .react-json-view * {
            background-color: white !important;
            color: #000 !important;
          }
          .json-editor .pretty-json-container,
          .json-editor .object-container,
          .json-editor .array-container {
            background: white !important;
          }
          .json-editor .object-key,
          .json-editor .object-key *,
          .json-editor .key,
          .json-editor .key * {
            color: #000 !important;
            background: white !important;
          }
        `}
      </style>
      <JsonView
        src={json}
        onEdit={readOnly ? undefined : (edit: { updated_src: unknown }) => {
          onChange(edit.updated_src as JsonData);
        }}
        onAdd={readOnly ? undefined : (add: { updated_src: unknown }) => {
          onChange(add.updated_src as JsonData);
        }}
        onDelete={readOnly ? undefined : (del: { updated_src: unknown }) => {
          onChange(del.updated_src as JsonData);
        }}
        theme="bright"
        displayDataTypes={false}
        collapsed={false}
        sortKeys={true}
        style={{ textAlign: 'left', background: 'white', color: 'black' }}
      />
    </div>
  );
};
